import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

const BannerSlider = ({ banners, autoSlideInterval = 5000 }) => {
  return (
    <div className="platform-banner">
      <Swiper
        modules={[Autoplay]}
        spaceBetween={0}
        slidesPerView={1}
        autoplay={{
          delay: autoSlideInterval,
          disableOnInteraction: false,
        }}
        loop={true}
        speed={500}
      >
        {banners.map((banner, index) => (
          <SwiperSlide key={index}>
            <a href={banner.url} target="_blank" rel="noreferrer">
              <img
                src={banner.image}
                alt={banner.alt}
                style={{
                  width: "100%",
                  height: "auto",
                  display: "block",
                }}
              />
            </a>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default BannerSlider;
